module.exports = __webpack_public_path__ + "assets/img/thumb-VentureCrowd-Article.bad40bda.webp";